export enum EBooleanSensorType {
  /**Not recognized sensor. */
  Unknown = 0,

  /**
   * Plate presence sensor.
   * @para  Value = true means plate is exist/present.
   */
  PlatePresenceSensor = 1,

  /**
   * Crash sensor.
   * @para  Value = true means crash is currently happening.
   */
  CrashSensor = 2,

  /**
   * SBS plate footprint sensor.
   * @para  Value = true means the plate footprint is SBS.
   */
  SbsPlateFootprintSensor = 3,

  /**
   * Load port door sensor.
   * @para  Value = true means the load port door is open.
   */
  LoadPortDoorSensor = 4,

  /**
   * Main door sensor.
   * @para  Value = true means the main door is open.
   */
  MainDoorSensor = 5,
}